import { CircularProgress, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

/** The first data of a selection is on its way and there is no earlier chart to keep showing. */
export function TimeSeriesChartLoadingState() {
  const { t } = useTranslation();

  return (
    <Stack
      role="status"
      aria-live="polite"
      sx={{ flex: 1, minHeight: 0, alignItems: 'center', justifyContent: 'center', gap: 1 }}
    >
      <CircularProgress aria-label={t('timeSeriesChart.chart.loading')} />
      <Typography>{t('timeSeriesChart.chart.loading')}</Typography>
    </Stack>
  );
}
